module.exports = __webpack_public_path__ + "assets/img/59c20aecb5f15fdd045216103fd8edde.png";